/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { post } from "../../../utils/sysAxios";
import { Button } from "primereact/button";
import { toastError } from "../../../utils/sysToast";
import SysTable from "../../commonComponents/SysTable";

class Logs extends Component {
  state = {
    tableData: [],
  };

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.fileName"),
        field: "FILE_NAME",
      },
      {
        id: 2,
        label: t("col.sizeKb"),
        field: "SIZE_KB",
        width: "120px",
      },
      {
        id: 3,
        label: t("col.lastModified"),
        field: "LAST_MODIFIED",
        width: "180px",
      },
      {
        id: 4,
        label: t("col.actions"),
        field: "SYS_ACTIONS",
        width: "110px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => (
          <div id="outer">
            <div className="inner" title={t("btn.export")}>
              <button
                className="dropdown-item btn-popup-menu"
                disabled={this.props.isLoading}
                onClick={() => this.handleDownload(data.FILE_NAME)}
              >
                <i className="fa fa-download" />
              </button>
            </div>
          </div>
        ),
      },
    ];
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    post("/api/data/GetLogFiles", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        if (apiResponse && apiResponse.data.respCode === 0) {
          this.setState({ tableData: apiResponse.data.respData.data });
        }
      }
    );
  }

  handleDownload(fileName) {
    post(
      "/api/data/DownloadLogFile",
      { fileName },
      this.props.updateIsLoading,
      "blob"
    ).then((apiResponse) => {
      if (!apiResponse || !apiResponse.data) return;

      if (!(apiResponse.data instanceof Blob)) {
        toastError("Download failed");
        return;
      }

      const url = window.URL.createObjectURL(apiResponse.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    });
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.systemLogs")}</h4>
          </div>
          <div className="col flex-container-left">
            <Button
              label={t("btn.refresh")}
              icon="fa fa-refresh"
              className="p-button-rounded p-button-secondary"
              disabled={this.props.isLoading}
              onClick={() => this.getData()}
            />
          </div>
        </div>
        <hr />
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(Logs);
